import { t } from '@/plugins/i18n';
const helpUrls = require('@/configuration/help.json');

export default [
  {
    path: '/dashboard',
    component: () => import('@/views/private/dashboard/DashboardView.vue'),
    name: 'dashboard',
    meta: { title: t('navigation.home') },
  },
  {
    path: 'beneficiaries/list',
    component: () => import('@/views/private/beneficiaries/BeneficiariesList.vue'),
    name: 'beneficiariesList',
    meta: {
      title: t('sidebar.beneficiariesList'),
      helpUrl: helpUrls.beneficiaryList,
      breadcrumb: [{ label: t('sidebar.beneficiaries') }],
    },
  },
  {
    path: 'beneficiaries/:uniqueIdentificationNumber/details',
    component: () => import('@/views/private/beneficiaries/item/BeneficiariesItem.vue'),
    name: 'beneficiary',
    meta: {
      title: t('sidebar.beneficiariesList'),
      helpUrl: helpUrls.beneficiaryList,
      breadcrumb: [
        { label: t('sidebar.beneficiaries') },
        { label: t('sidebar.beneficiariesList'), link: { name: 'beneficiariesList' } },
      ],
      size: 'md',
    },
  },
  {
    path: 'beneficiaries/export',
    component: () => import('@/views/private/beneficiaries/export/BeneficiariesExport.vue'),
    name: 'beneficiariesExport',
    meta: {
      title: t('sidebar.beneficiariesExport'),
      helpUrl: helpUrls.beneficiaryLoad,
      breadcrumb: [{ label: t('sidebar.beneficiaries') }],
      size: 'sm',
    },
  },
  {
    path: 'beneficiaries/reissue-export',
    component: () => import('@/views/private/beneficiaries/reissue-export/BeneficiariesReissueExport.vue'),
    name: 'beneficiariesReissueExport',
    meta: {
      title: t('sidebar.beneficiariesReissueExport'),
      helpUrl: helpUrls.beneficiaryLoad,
      breadcrumb: [{ label: t('sidebar.beneficiaries') }],
      size: 'sm',
    },
  },
  {
    path: 'beneficiaries/import',
    component: () => import('@/views/private/beneficiaries/load/BeneficiariesLoad.vue'),
    name: 'beneficiariesImport',
    meta: {
      title: t('sidebar.beneficiariesLoad'),
      helpUrl: helpUrls.beneficiaryLoad,
      breadcrumb: [{ label: t('sidebar.beneficiaries') }],
      size: 'sm',
    },
  },
  {
    path: 'beneficiaries/update',
    component: () => import('@/views/private/beneficiaries/update/BeneficiariesUpdate.vue'),
    name: 'beneficiariesUpdate',
    meta: {
      title: t('sidebar.beneficiariesUpdate'),
      helpUrl: helpUrls.beneficiaryUpdate,
      breadcrumb: [{ label: t('sidebar.beneficiaries') }],
      size: 'sm',
    },
  },
  {
    path: 'beneficiaries/reissue',
    component: () => import('@/views/private/beneficiaries/reissue/BeneficiariesCardReissue.vue'),
    name: 'beneficiariesReissue',
    meta: {
      title: t('sidebar.beneficiariesCardReissue'),
      helpUrl: helpUrls.beneficiaryReissue,
      breadcrumb: [{ label: t('sidebar.beneficiaries') }],
      size: 'sm',
    },
  },
  {
    path: 'beneficiaries/activation',
    component: () => import('@/views/private/beneficiaries/activation/RequestActivation.vue'),
    name: 'requestActivation',
    meta: {
      title: t('sidebar.requestActivation'),
      helpUrl: helpUrls.requestActivation,
      breadcrumb: [{ label: t('sidebar.requestActivation') }],
      size: 'sm',
    },
  },
  {
    path: 'beneficiaries/deny',
    component: () => import('@/views/private/beneficiaries/denial/BeneficiariesDeny.vue'),
    name: 'requestDenial',
    meta: {
      title: t('sidebar.requestDenial'),
      helpUrl: helpUrls.requestDenial,
      breadcrumb: [{ label: t('sidebar.beneficiaries') }],
      size: 'sm',
    },
  },
  {
    path: 'issues/list',
    component: () => import('@/views/private/issues/IssueList.vue'),
    name: 'issueList',
    meta: {
      title: t('sidebar.issueList'),
      helpUrl: helpUrls.issueList,
      breadcrumb: [{ label: t('sidebar.issues') }],
      size: 'xl',
    },
  },
  {
    path: 'issues/:issueId/details',
    component: () => import('@/views/private/issues/item/IssueItem.vue'),
    name: 'issue',
    meta: {
      title: t('sidebar.issueList'),
      helpUrl: helpUrls.issueList,
      breadcrumb: [{ label: t('sidebar.issues') }, { label: t('sidebar.issueList'), link: { name: 'issueList' } }],
      size: 'md',
    },
  },
];
